"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CardProfileSkills;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
function CardProfileSkills(_ref) {
  var image = _ref.image,
      title = _ref.title,
      description = _ref.description,
      list = _ref.list,
      dropdown = _ref.dropdown;
  var colorClass = {
    blueGray: "text-blueGray-500 bg-blueGray-200",
    red: "text-red-500 bg-red-200",
    orange: "text-orange-500 bg-orange-200",
    amber: "text-amber-500 bg-amber-200",
    emerald: "text-emerald-500 bg-emerald-200",
    teal: "text-teal-500 bg-teal-200",
    lightBlue: "text-lightBlue-500 bg-lightBlue-200",
    indigo: "text-indigo-500 bg-indigo-200",
    purple: "text-purple-500 bg-purple-200",
    pink: "text-pink-500 bg-pink-200"
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "shadow-lg rounded-lg relative flex flex-col min-w-0 break-words bg-white w-full mb-6"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "w-full flex-shrink-0 rounded-lg",
    src: image,
    alt: "..."
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute w-full p-4 bottom-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-white rounded p-6 w-full"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "text-2xl font-bold leading-tight mt-0 mb-1"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-lg font-normal leading-normal mb-4 text-blueGray-400"
  }, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "block w-full overflow-x-auto"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full"
  }, list.map(function (prop, key) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: key,
      className: "border-t border-blueGray-200 flex items-center justify-between py-2"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "inline-flex text-center rounded-full mr-3 items-center justify-center w-8 h-8 text-sm " + colorClass[prop.color]
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: prop.icon
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "text-blueGray-500 uppercase text-sm font-bold"
    }, prop.leftText)), /*#__PURE__*/_react.default.createElement("span", null, prop.rightText));
  })))))));
}

CardProfileSkills.defaultProps = {
  list: [],
  dropdown: {}
};
CardProfileSkills.propTypes = {
  image: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.string,
    color: _propTypes.default.oneOf(["blueGray", "red", "orange", "amber", "emerald", "teal", "lightBlue", "indigo", "purple", "pink"]),
    leftText: _propTypes.default.string,
    rightText: _propTypes.default.string
  })),
  // props that can be passed to the DropdownButton component
  dropdown: _propTypes.default.object
};
